import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { collection, onSnapshot, query } from "firebase/firestore";
import { CreateData } from "../firebase Component/CreateData";
import { db } from "../firebase Component/firebase-config";
import wavFile from "../audio/audio.wav";
function MsgBox(props) {
  const msgArr = String(props.message).split("(break)");
  return (
    <div>
      <h1 className="title-font sm:text-3xl text-2xl mb-4 font-poppinsBold text-cusOrange  ali">
        {props.name}
      </h1>

      <h1 className="title-font sm:text-4xl text-3xl mb-4 font-poppinsBold text-cusOrange  ali">
        {props.title}
      </h1>

      <div className="invisible"></div>
      <h1 className="title-font sm:text-xl text-lg m-24 font-poppinsLight text-gray-900 ali">
        {msgArr.map((item, index) => {
          return (
            <p>
              {item}

              <br />
            </p>
          );
        })}
      </h1>
    </div>
  );
}

const MsgRendering = ({
  message,
  title,
  name,
  date,
  Id,
  read,
  collection,
  fav,
}) => {
  // eslint-disable-next-line
  const [Read, setRead] = useState(read);
  // eslint-disable-next-line
  const [Fav, setFav] = useState(fav);
  return (
    <div className="text-center lg:w-2/3 w-auto h-full">
      <MsgBox message={message} title={title} name={name} />
      <div>
        <div className="flex">
          {/* <button
          class="mx-auto mb-10 mt-10 bg-cusOrange text-white bg-yellow-500 border-0 py-2 px-8 focus:outline-none hover:bg-yellow-600 rounded text-lg"
          onClick={() => {
            UpdateData(Id, { read: !Read }, collection);
            setRead(!Read);
          }}
        >
          Read {Read ? "✔️" : null}
        </button>
        <button
          class="mx-auto mb-10 mt-10 bg-cusOrange text-white bg-yellow-500 border-0 py-2 px-8 focus:outline-none hover:bg-yellow-600 rounded text-lg"
          onClick={() => {
            UpdateData(Id, { fav: !Fav }, collection);
            setFav(!Fav);
          }}
        >
           {Fav ? "❤️" : "🖤"}
        </button> */}
        </div>

        <h2 className="title-font sm:text-2xl text-1xl mb-4 font-poppinsBold text-cusOrange font-light">
          {date}
        </h2>
      </div>
      <div class="p-2 w-full pt-8 mt-8 border-t border-cusOrange text-center"></div>
    </div>
  );
};
function sort_by_number() {
  return function (elem1, elem2) {
    if (elem1.number < elem2.number) {
      return -1;
    } else if (elem1.number > elem2.number) {
      return 1;
    } else {
      return 0;
    }
  };
}

function MuaazLive() {
  const CollectionName = "LiveChat";
  const [Data, setData] = useState([]);
  const dataRef = collection(db, String(CollectionName));
  const [index, setIndex] = useState(null);

  const ref = useRef();
  //   const DataFetching = async () => {
  //     const data = await getDocs(dataRef);

  //      const ArrData = data.docs.map((recData) => ({ ...recData.data(), id: recData.id }))
  //      setIndex(ArrData.length+1)
  //     const Arr = ArrData.filter((num)=> num.read === false)
  //      Arr.sort(sort_by_number())
  //      setData(Arr)

  //   };

  const SetData = (data) => {
    const ArrData = data;
    setIndex(ArrData.length + 1);
    const Arr = ArrData.filter((num) => num.read === false);
    Arr.sort(sort_by_number());
    setData(Arr);
  };

  //   // eslint-disable-next-line
  //   useEffect(() => {
  //     DataFetching();

  //     // eslint-disable-next-line
  //   }, []);

  const [formData, setFormData] = useState({
    msg: "",
  });

  const HandleChange = (name, data) => {
    setFormData({ ...formData, [name]: data });
  };

  const SendData = () => {
    var today = new Date();
    var date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    var time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date + " at " + time;
    var TransmitDataValue = {
      name: "Maazy",
      msg: formData.msg,
      date: dateTime,
      read: false,
      number: index,
      fav: false,
    };
    TransmitData(TransmitDataValue);
  };
  const TransmitData = (newData) => {
    CreateData(CollectionName, newData);

    // setTimeout(() => {
    //   window.location.reload();
    // }, 3000);
  };

  useEffect(() => {
    const queryMessages = query(dataRef);
    const unsuscribe = onSnapshot(queryMessages, (snapshot) => {
      let messages = [];
      snapshot.forEach((doc) => {
        messages.push({ ...doc.data(), id: doc.id });
      });
      SetData(messages);
      const audio = new Audio(wavFile);
      audio.play();
    });

    return () => unsuscribe();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container  mx-auto flex px-0 py-0 pt-3 items-center  justify-center flex-col">
      {Data &&
        Data.map((data, index) => {
          return (
            <MsgRendering
              message={data.msg}
              title={data.title}
              key={index}
              name={data.name}
              Id={data.id}
              date={data.date}
              read={data.read}
              collection={CollectionName}
              fav={data.fav}
            />
          );
        })}
      <section class="text-gray-600 body-font relative">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-col text-center w-full mb-12">
            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
              Write your Msg Here
            </h1>
          </div>
          <div class="lg:w-1/2 md:w-2/3 mx-auto">
            <div class="flex flex-wrap -m-2">
              <div class="p-2 w-1/2 invisible">
                <div class="relative">
                  <label
                    for="countries"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Choose the name
                  </label>
                  <select
                    id="countries"
                    class="bg-gray-50 border border-gray-300 text-cusOrange text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option selected>Name</option>
                    <option value="Maazy">Maazy</option>
                    <option value="Zaino">Zaino</option>
                  </select>
                </div>
              </div>
              <div class="p-2 w-1/2 invisible">
                <div class="relative">
                  <label for="email" class="leading-7 text-sm text-gray-600">
                    Title
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-yellow-500 focus:bg-white focus:ring-2 focus:ring-yellow-200 text-base outline-none text-cusLightBlack py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  />
                </div>
              </div>
              <div class="p-2 w-full">
                <div class="relative">
                  <label for="message" class="leading-7 text-sm text-gray-600">
                    Message
                  </label>
                  <textarea
                    ref={ref}
                    id="message"
                    name="message"
                    class="w-full bg-gray-100 bg-opacity-50 text-cusLightBlack rounded border border-gray-300 focus:border-yellow-500 focus:bg-white focus:ring-2 focus:ring-yellow-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                    onChange={(e) => {
                      HandleChange("msg", e.target.value);
                    }}
                    required={true}
                  ></textarea>
                </div>
              </div>
              <div class="p-2 w-full">
                <button
                  class={`flex mx-auto bg-cusOrange text-white bg-yellow-500 border-0 py-2 px-8 focus:outline-none hover:bg-yellow-600 rounded text-lg `}
                  onClick={() => {
                    SendData();
                    ref.current.value = "";
                  }}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MuaazLive;
